<template>
  <div style="padding-top: 85px;">
		<header-list></header-list>
		
		<div class="about-div">
			<!-- 当前位置 -->
			<div class="ptb-30 f-20 c-33">
				当前位置: 关于我们
			</div>
			
			<div class="bg-ff main-box flex flex-y-s">
				<!-- 左边导航 -->
				<div class="about-left">
					<div class="title flex-dir-col flex-c c-ff">
						<p class="f-20 bold" style="margin: 0;">关于我们</p>
						<p style="margin: 0;">About Us</p>
					</div>
					
					<ul class="pt-10 pb-50">
						<li class="mt-10 t-c f-18 c-33 shou" @click="changeAbout(item.id,item)" v-for="item,index in about_list" :key="index">{{item.SYS_TOPIC}}</li>
					</ul>
				</div>
				<!-- 右边内容 -->
				<div class="flex-box pt-20 plr-30 about-right">
					<div class="title f-18 c-33 pb-10 bold" v-if="title">{{title[0].SYS_TOPIC}}</div>
					<div class="ptb-15" v-html="XINWENZIXUN_DOC_EXPLAIN"></div>
				</div>
			</div>
		</div>
		
		<footer-view></footer-view>
	</div>
</template>

<script>
import headerList from './header_nav.vue'
import footerView from './footer.vue'
export default {
  data () {
    return {
			about_list: [],
			id: 0,
			title: 0,
			XINWENZIXUN_DOC_EXPLAIN: ''
		}
  },
	
	components: {
		headerList,
		footerView,
	},

  created () {
		this.id = this.$route.query.id
	},
	
	mounted () {
		this.bindBottom()
		// this.getnewsinfo()
	},

  methods: {
		// 获取尾部关于我们部分
		async bindBottom () {
				 let _this = this
				 let data = { 
				 			conditions:JSON.stringify([{pub_col_id:82},{pub_sale_status:1}]),
				 			orderBy: "pub_a_order asc pub_lastmodified desc id asc",
				 			pageNo:1,
				 			pageSize:15,
				 			searchText:"",
				 		}
				 const res = await _this.post('/spc/cms/publish/list.do', data )
				 if ( res.success) {
				 	 _this.about_list = res.result
					 _this.title = res.result.filter(x => x.id == _this.id)
					 this.getnewsinfo(res.result[0].pub_site_ids[0],res.result[0].pub_col_id)
				 } else {
				 		_this.$Message.error(res.description);
				 }
		},
		
		// 获取新闻详情
		async getnewsinfo(siteId,colld) {
			let _this = this
					_this.$Spin.show()
					let datainfo = {
						pubId: _this.id,
						siteId,
						colld,
					}
			const res = await _this.get('/resource/detail.do', datainfo )
			if ( res.successResult) {
						_this.XINWENZIXUN_DOC_EXPLAIN = res.data.XINWENZIXUN_DOC_EXPLAIN
						_this.$Spin.hide()
			}
		},
		
		changeAbout (id,item) {
			console.log(item);
			let _this = this
			_this.id = id
			_this.title = _this.about_list.filter(x => x.id == _this.id)
			this.getnewsinfo(item.pub_site_ids[0],item.pub_col_id)
		}
	},
	
	watch: {
		'$route' () {
			this.id = this.$route.query.id
			 this.title = this.about_list.filter(x => x.id == this.id)
			 this.getnewsinfo()
		}
	},
	
}
</script>

<style lang="less" scoped>
.about-div {
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 40px;
}
.main-box {
	box-shadow: 0 0 5px #ccc;
}
.about-left {
	width: 200px;
	.title {
		background-color: #cc1720;
		height: 60px;
	}
	background-color: #f9f9f9;
	height: 100%;
}
.about-right {
	.title {
		border-bottom: 1px solid #eee;
	}
}
</style>
